/* Pygmalion: adds the free-delivery bar, the complimentary gift card notice and the
   "Pairs beautifully with" row to the slide-out basket.
   Content comes from templates/cart.pyg-extras.liquid.
   Also: on desktop the basket no longer dims or locks the page; it sits at the right
   and pushes the page to the left so shoppers can keep browsing and adding. */
(() => {
  const css = `
  .pyg-ship{padding:0 2rem 1.6rem;border-bottom:1px solid rgba(56,27,33,.12)}
  .pyg-ship__track{height:4px;background:rgba(56,27,33,.12);border-radius:2px;overflow:hidden}
  .pyg-ship__track i{display:block;height:100%;background:#381B21;transition:width .4s ease}
  .pyg-ship__msg{margin:1rem 0 0;text-align:center;font-family:var(--pyg-kindersley,Georgia,serif);font-size:14px;line-height:1.4;color:#381B21}
  .pyg-ship__msg b{font-weight:400;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:11.5px;letter-spacing:.12em;text-transform:uppercase}
  .pyg-card{display:flex;gap:14px;align-items:flex-start;margin-top:1rem;padding:1.4rem 1.2rem;background:#BFCBC7;color:#381B21}
  .pyg-card__art{flex:0 0 64px;line-height:0}
  .pyg-card__art img,.pyg-card__art svg{width:64px;height:auto;display:block}
  .pyg-card__text{flex:1;min-width:0}
  .pyg-card__title{margin:0;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:11.5px;letter-spacing:.12em;text-transform:uppercase;line-height:1.3}
  .pyg-card__msg{margin:.4rem 0 0;font-family:var(--pyg-kindersley,Georgia,serif);font-size:14px;line-height:1.45;overflow-wrap:anywhere}
  .pyg-card__msg--empty{opacity:.85}
  .pyg-card__edit,.pyg-card__save{margin-top:.6rem;padding:0;border:0;background:none;cursor:pointer;color:#381B21;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px}
  .pyg-card__form textarea{width:100%;margin-top:.6rem;min-height:64px;border:0;background:#FAFAFA;padding:10px;font-family:var(--pyg-kindersley,Georgia,serif);font-size:14px;line-height:1.45;color:#381B21;resize:vertical;box-sizing:border-box}
  .pyg-card__save[aria-busy="true"]{opacity:.5;pointer-events:none}
  .pyg-pair{padding:2rem 0 1rem;border-top:1px solid rgba(56,27,33,.12);margin-top:1rem}
  .pyg-pair__head{margin:0 0 1.4rem;text-align:center;font-family:var(--pyg-kindersley,Georgia,serif);font-size:16px;color:#381B21}
  .pyg-pair__row{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
  .pyg-pair__card{text-align:center}
  .pyg-pair__card img{width:100%;height:auto;aspect-ratio:1;object-fit:cover;display:block;margin-bottom:6px}
  .pyg-pair__name{margin:0;font-family:'Montage-Serif-Font',Georgia,serif;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:#381B21}
  .pyg-pair__price{margin:2px 0 8px;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:12px;color:#381B21}
  .pyg-pair__add{width:100%;min-height:34px;border:1px solid #381B21;background:transparent;color:#381B21;cursor:pointer;font-family:var(--pyg-acumin,Arial,sans-serif);font-size:10.5px;letter-spacing:.12em;text-transform:uppercase;transition:background .15s,color .15s}
  .pyg-pair__add:hover{background:#381B21;color:#FAFAFA}
  .pyg-pair__add[aria-busy="true"]{opacity:.5;pointer-events:none}
  @media(min-width:750px){
    body{transition:margin-right .3s ease}
    body:has(cart-drawer.active){margin-right:40rem;overflow-y:auto!important}
    html:has(cart-drawer.active){overflow-y:auto!important}
    cart-drawer.active{background:transparent!important;pointer-events:none}
    cart-drawer.active .drawer__inner{pointer-events:auto;box-shadow:-1px 0 0 rgba(56,27,33,.18)}
    cart-drawer .cart-drawer__overlay{display:none!important}
  }`;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  let busy = false;
  let queued = false;
  let selfMutating = false;

  async function inject() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    if (busy) { queued = true; return; }
    /* Don't wipe a message someone is still typing */
    if (drawer.querySelector('.pyg-card__form:not([hidden])')) return;
    busy = true;
    try {
      const html = await (await fetch(root() + 'cart?view=pyg-extras', { credentials: 'same-origin' })).text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const ship = doc.querySelector('#pyg-ship-src .pyg-ship');
      const card = doc.querySelector('#pyg-card-src .pyg-card');
      const pair = doc.querySelector('#pyg-pair-src .pyg-pair');
      selfMutating = true;
      drawer.querySelectorAll('.pyg-ship, .pyg-card, .pyg-pair').forEach((el) => el.remove());
      const header = drawer.querySelector('.drawer__header');
      if (ship && header) header.after(ship);
      const items = drawer.querySelector('#CartDrawer-CartItems .drawer__cart-items-wrapper');
      if (pair && items) items.after(pair);
      if (card && items) items.after(card);
      setTimeout(() => { selfMutating = false; }, 0);
    } catch (e) { selfMutating = false; /* the basket still works without the extras */ }
    busy = false;
    if (queued) { queued = false; inject(); }
  }

  function watch() {
    const drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    let timer;
    /* Dawn re-renders parts of the basket after every change; refresh our bits each time */
    new MutationObserver(() => {
      if (selfMutating) return;
      clearTimeout(timer);
      timer = setTimeout(inject, 60);
    }).observe(drawer, { childList: true, subtree: true });
    inject();
  }

  document.addEventListener('click', async (event) => {
    const edit = event.target.closest('.pyg-card__edit');
    if (edit) {
      const form = edit.parentElement.querySelector('.pyg-card__form');
      selfMutating = true;
      form.hidden = !form.hidden;
      edit.setAttribute('aria-expanded', String(!form.hidden));
      edit.hidden = !form.hidden;
      setTimeout(() => { selfMutating = false; }, 0);
      if (!form.hidden) form.querySelector('textarea').focus();
      return;
    }

    const save = event.target.closest('.pyg-card__save');
    if (save) {
      const form = save.closest('.pyg-card__form');
      const message = form.querySelector('textarea').value.trim();
      save.setAttribute('aria-busy', 'true');
      try {
        await fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { 'Gift card': 'Yes', 'Gift card message': message } })
        });
        /* Tell the gift box page, so its own note box shows the same message. */
        document.dispatchEvent(new CustomEvent('pyg:gift-card-saved', { detail: { message } }));
      } catch (e) { /* leave the form open so nothing is lost */ }
      form.hidden = true;
      inject();
      return;
    }

    const btn = event.target.closest('.pyg-pair__add');
    if (!btn) return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(btn.dataset.variantId), quantity: 1, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
      });
      const state = await res.json();
      const cartDrawer = document.querySelector('cart-drawer');
      if (res.ok && cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(state);
      } else {
        btn.removeAttribute('aria-busy');
      }
    } catch (e) {
      btn.removeAttribute('aria-busy');
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
